import React, { useEffect, useState } from "react";
import { Badge, Card, Col, Container, Form, InputGroup, ListGroup, Row, Spinner, Table } from "react-bootstrap";
import { useParams } from "react-router-dom";
import SplitPane from "react-split-pane";
import { NoDataFoundTable, PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";
import { studyEventFormSchemaServices } from "../../../../APIServices/studyEventFormSchemaServices";
import { studyEventManagementServices } from "../../../../APIServices/CTMS/EventManagement/studyEventManagementServices";
import { studyMedicalReviewServices } from "../../../../APIServices/studyMedicalReviewServices";
import Swal from "sweetalert2";
import { BsBuildingsFill, BsCheck2All, BsClock, BsEye, BsFileText } from "react-icons/bs";
import { PiWarning } from "react-icons/pi";
import ReviewStatusDistribution from "./ReviewStatusDistribution";
import CompletionbyForm from "./CompletionbyForm";
import ReviewerPerformance from "./ReviewerPerformance";
import { CiSearch } from "react-icons/ci";
import UseToggle from "../../../../Hooks/UseToggle";
import FilterMedicalTask from "./FilterMedicalTask";
import Pagination from "../../../Pagination";
import ReviewQueryHistory from "../../FormManagement/FormList/ReviewQueryHistory";
import QueryStatusDistribution from "./QueryStatusDistribution";
import { FaXmark } from "react-icons/fa6";

const TaskManagement = ({ onMouseDown, tableRef, handleAddNewTab }) => {
  const [siteId, setSiteId] = useState("");
  const [subjectId, setSubjectId] = useState("");
  const [eventId, setEventId] = useState("");
  const [timePointId, setTimePointId] = useState("");
  const [formId, setFormId] = useState("");
  const [taskList, setTaskList] = useState([]);
  const [taskCount, setTaskCount] = useState(0);
  const [taskAnalytics, setTaskAnalytics] = useState("");
  const [loading, setLoading] = useState(false);
  const [taskLoading, setTaskLoading] = useState(false);
  let { studyId } = useParams();
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const [taskData, setTaskData] = useState("");
  const [type, setType] = useState("ALL");
  const toggles = UseToggle();

  const studyPermission = JSON.parse(localStorage.getItem("studyPermissionData"));
  const dataType = (StudyMode === "Live Mode" || StudyMode === "QC Mode") ? ((studyPermission?.liveSummeryMedicalReview || studyPermission?.qcSummeryMedicalReview) ? "ALL" : "MY") : (StudyMode === "SDV Live Mode" || StudyMode === "SDV QC Mode") ? ((studyPermission?.liveSDVSummeryMedicalReview || studyPermission?.qcSDVSummeryMedicalReview) ? "ALL" : "MY") : "MY"

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(taskCount / itemsPerPage);

  const getSubjectMedicalReviewTask = async () => {
    setLoading(true);
    let data = await studyMedicalReviewServices.getSubjectMedicalReviewTask(
      studyId,
      "edc",
      "pending",
      type,
      dataType,
      StudyMode,
      siteId,
      subjectId,
      formId,
      eventId,
      timePointId,
      pageNumber,
      itemsPerPage,
    );
    setTaskList(data?.data || []);
    setTaskCount(data?.count || 0);
    setLoading(false);
  };

  const getTaskManagementAnalytics = async () => {
    setTaskLoading(true)
    let data = await studyMedicalReviewServices.getTaskManagementAnalytics(studyId, type, dataType, StudyMode)
    setTaskAnalytics(data?.data || "")
    setTaskLoading(false)
  }

  const isOverdue = (dateString) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const givenDate = new Date(dateString);
    givenDate.setHours(0, 0, 0, 0);

    return givenDate < today ? "Yes" : "No";
  };

  const overviewCards = [
    {
      title: "Total Tasks",
      value: taskAnalytics?.totalTask || 0,
      subtitle: "All assigned review tasks",
      icon: <BsFileText className="bg-white text-info shadow-sm" />,
    },
    {
      title: "Pending Tasks",
      value: taskAnalytics?.totalPendingTask || 0,
      subtitle: "Awaiting review completion",
      icon: <BsClock className="bg-white text-warning shadow-sm" />,
    },
    {
      title: "Pass Tasks",
      value: taskAnalytics?.totalPassedTask || 0,
      subtitle: "Successfully reviewed",
      icon: <BsCheck2All className="bg-white text-success shadow-sm" />,
    },
    {
      title: "Failed Tasks",
      value: taskAnalytics?.totalFailedTask || 0,
      subtitle: "Require corrective action",
      icon: <FaXmark className="bg-white text-danger shadow-sm" />,
    },
    {
      title: "Open Queries",
      value: taskAnalytics?.totalOpenComment || 0,
      subtitle: "Need attention",
      icon: <PiWarning className="bg-white text-danger shadow-sm" />,
    },
  ];

  const completedOverviewCards = [
    {
      title: "Total Tasks",
      value: taskAnalytics?.totalTask,
      subtitle: "Completed review activities",
      icon: <BsFileText className="bg-white text-info shadow-sm" />,
    },
    {
      title: "Avg. Turnaround",
      value: taskAnalytics?.avgTurnaround,
      subtitle: "Average review completion time",
      icon: <BsClock className="bg-white text-warning shadow-sm" />,
    },
    {
      title: "Review Complete",
      value: taskAnalytics?.completedReview,
      subtitle: "Successfully finalized reviews",
      icon: <BsCheck2All className="bg-white text-success shadow-sm" />,
    },
    {
      title: "Open Queries",
      value: taskAnalytics?.totalOpenComment,
      subtitle: "Awaiting resolution",
      icon: <PiWarning className="bg-white text-danger shadow-sm" />,
    },
  ];

  useEffect(() => {
    getSubjectMedicalReviewTask();
  }, [studyId, type, dataType, siteId,
    subjectId,
    formId,
    eventId,
    timePointId, pageNumber, itemsPerPage]);

  useEffect(() => {
    getTaskManagementAnalytics();
  }, [studyId, type, dataType]);

  return (
    <>
      <div
        className="justify-content-between toolbar border-bottom hstack p-1"
        style={{ height: 36 }}
      >
        <InputGroup className="w-auto">
          <button onClick={() => setType("ALL")} className={`updateProfile ${type === "ALL" ? "activee" : ""}`}>
            All
          </button>
          <button onClick={() => setType("7D")} className={`updateProfile ${type === "7D" ? "activee" : ""}`}>
            7D
          </button>
          <button onClick={() => setType("30D")} className={`updateProfile ${type === "30D" ? "activee" : ""}`}>
            30D
          </button>
          <button onClick={() => setType("QTD")} className={`updateProfile ${type === "QTD" ? "activee" : ""}`}>
            QTD
          </button>
        </InputGroup>
        <button className="updateProfile">Export</button>
      </div>
      <SplitPane
        split="vertical"
        minSize={"100%"}
        className="position-relative"
        style={{ height: "calc(100vh - 182px)" }}
      >
        {taskLoading ? (
          <PageLoader />
        ) : (
          <>
            <div className="p-2 chart__overview hstack justify-content-between gap-3">
              {overviewCards?.map((item, index) => (
                <div key={index} className="h-100 w-100">
                  <Card className="app-card bg-light border">
                    <Card.Body>
                      <div className="d-flex gap-3">
                        <div className="study_icopn">{item.icon}</div>
                        <div>
                          <Card.Title style={{ fontSize: 16 }}>{item.title}</Card.Title>
                          <Card.Text className="m-0">{item.value || "0"}</Card.Text>
                          <Card.Text style={{ fontSize: 11 }}>{item.subtitle}</Card.Text>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </div>
              ))}
            </div>
            {loading ? (
              <PageLoader />
            ) : taskList?.length === 0 ? "" : (
              <>
                <div
                  className="justify-content-between toolbar border-bottom border-top hstack p-1"
                  style={{ height: 36 }}
                >
                  <div className="hstack gap-1">
                    <i className="fa slid fa-filter" onClick={() => toggles.setToggle()}></i>
                  </div>
                </div>
                <Table ref={tableRef} className="m-0 custom-table" hover striped>
                  <thead className="position-sticky top-0 z-1">
                    <tr>
                      <th
                        onMouseDown={(e) => onMouseDown(e, 0)}
                        style={{ width: 45 }}
                        className="text-center"
                      >
                        Sr.
                      </th>

                      <th onMouseDown={(e) => onMouseDown(e, 1)}>Site Id</th>

                      <th onMouseDown={(e) => onMouseDown(e, 2)}>Subject Id</th>

                      <th onMouseDown={(e) => onMouseDown(e, 3)}>Event Id</th>

                      <th onMouseDown={(e) => onMouseDown(e, 5)}>Form Name</th>

                      <th onMouseDown={(e) => onMouseDown(e, 6)}>Form Version</th>

                      <th onMouseDown={(e) => onMouseDown(e, 7)}>Assigned By</th>

                      <th style={{ width: 150 }} onMouseDown={(e) => onMouseDown(e, 8)}>
                        Assigned Date | Time
                      </th>

                      <th onMouseDown={(e) => onMouseDown(e, 9)}>Assigned To</th>
                      <th onMouseDown={(e) => onMouseDown(e, 10)}>Due Date</th>

                      <th onMouseDown={(e) => onMouseDown(e, 11)}>Overdue</th>

                      <th
                        onMouseDown={(e) =>
                          onMouseDown(e, 12)
                        }
                      >
                        Status
                      </th>
                      <th
                        onMouseDown={(e) =>
                          onMouseDown(e, 13)
                        }
                      >
                        Queries
                      </th>
                      <th
                        onMouseDown={(e) =>
                          onMouseDown(e, 14)
                        }
                      >
                        View
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {taskList?.map((metadata, index) => (
                      <tr key={index}>
                        <td className="text-center">{index + 1 + startIndex}</td>

                        <td>{metadata?.siteName}</td>

                        <td>{metadata?.subjectName}</td>

                        <td>
                          {metadata?.eventName}{" "}
                          {metadata?.timePointName
                            ? `(${metadata?.timePointName})`
                            : ""}
                        </td>

                        <td>{metadata?.formName}</td>

                        <td>{metadata?.version}</td>

                        <td>{metadata?.assignedBy}</td>

                        <td>{metadata?.assignedDT}</td>

                        <td>{metadata?.assignedTo}</td>
                        <td>{metadata?.dueDate}</td>

                        <td
                          className={`fw-bold ${isOverdue(metadata?.dueDate) === "Yes" ? "text-danger" : "text-success"}`}
                        >
                          {isOverdue(metadata?.dueDate)}
                        </td>
                        <td className="fw-bold text-muted text-capitalize">
                          {metadata?.status}
                        </td>
                        <td>
                          <button className={`updateProfile`}
                            onClick={() => { toggles.setToggle1(); setTaskData({ siteId: metadata?.siteId, reviewId: metadata?._id }) }}
                            style={{ padding: "1px 10px" }}>
                            View ({metadata?.totalQuery || 0})
                          </button>
                        </td>
                        <td>
                          <button
                            onClick={() =>
                              handleAddNewTab(
                                metadata?.timePointName
                                  ? `Site: ${metadata?.siteName} - Subject: ${metadata?.subjectName} - Event: ${metadata?.eventName} (${metadata?.timePointName})`
                                  : `Site: ${metadata?.siteName} - Subject: ${metadata?.subjectName} - Event: ${metadata?.eventName}`,
                                "",
                                "viewEventSchemaFormLists",
                                {
                                  siteId: metadata?.siteId,
                                  subjectId: metadata?.subjectId,
                                  schemaId: metadata?.schemaId,
                                  formId: metadata?.formId,
                                  formName: metadata?.formName,
                                  formVersion: metadata?.version,
                                  formType: metadata?.formType,
                                  recordId: metadata?.recordId || "",
                                  type: "eventForm",
                                  autoForm: "yes",
                                  viewType: "dataEntry",
                                  eventId: metadata?.eventId,
                                  timePointUniqueId: metadata?.timePointId
                                    ? String(metadata?.timePointId)
                                    : "",
                                },
                              )
                            }
                            className={`updateProfile`}
                            style={{ padding: "1px 10px" }}
                          >
                            View
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                <div className="position-sticky bottom-0 start-0">
                  <Pagination
                    totalPage={totalPage}
                    pageNumber={pageNumber}
                    itemsPerPage={itemsPerPage}
                    totalItems={taskCount}
                    setPageNumber={setPageNumber}
                    setItemsPerPage={setItemsPerPage}
                  />
                </div>
              </>
            )}
          </>
        )}
      </SplitPane>
      <FilterMedicalTask
        Show={!toggles.toggle}
        Hide={toggles.setToggle}
        Title={"Filter"}
        siteId={siteId}
        setSiteId={setSiteId}
        subjectId={subjectId}
        setSubjectId={setSubjectId}
        eventId={eventId}
        setEventId={setEventId}
        timePointId={timePointId}
        setTimePointId={setTimePointId}
        loading={loading}
        formId={formId}
        setFormId={setFormId}
        getSubjectMedicalReviewTask={getSubjectMedicalReviewTask}
      />
      <ReviewQueryHistory
        Show={!toggles.toggle1}
        Hide={toggles.setToggle1}
        Title={`Query History`}
        siteId={taskData?.siteId}
        reviewId={taskData?.reviewId}
        studyId={studyId}
        getSubjectMedicalReviewer={async () => {
          await getSubjectMedicalReviewTask();
          await getTaskManagementAnalytics();
        }}
      />
    </>
  );
};

export default TaskManagement;
